import axios from "axios";
import { LocalDate, LocalDateTime, LocalTime, ZoneId } from "@js-joda/core";
import '@js-joda/timezone';
export default class BookingService {
    requestPrice(from, to, productId) {
        return axios.get("booking/priceRequest", {
            params: {
                from: from,
                to: to,
                productId: productId
            }
        });
    }
    loadAvailabilitiesForProductSimple(productId, from, to, orderItemId) {
        const localDateFrom = LocalDateTime.of(LocalDate.of(from.getFullYear(), from.getMonth() + 1, from.getDate()), LocalTime.of(from.getHours(), from.getMinutes(), from.getSeconds()));
        const zonedDateTimeFrom = localDateFrom.atZone(ZoneId.of("Europe/Berlin"));
        const localDateTo = LocalDateTime.of(LocalDate.of(to.getFullYear(), to.getMonth() + 1, to.getDate()), LocalTime.of(to.getHours(), to.getMinutes(), to.getSeconds()));
        const zonedDateTimeTo = localDateTo.atZone(ZoneId.of("Europe/Berlin"));
        return axios.get('booking/availabilities', {
            params: {
                productId: productId,
                from: new Date(zonedDateTimeFrom.toInstant().toEpochMilli()),
                to: new Date(zonedDateTimeTo.toInstant().toEpochMilli()),
                orderItemId: orderItemId
            }
        }).then(response => response.data);
    }
}
